import client from "./client";

export async function verifyAddress(inputs: Record<string, unknown>) {
    const response = await client.post("/user/addresses/verify", inputs);

    return response.data;
}
